import React from "react";
import { usePrevious } from "react-use";

import { useScoped } from "~/tools/impulse";

import { BarChartSettings } from "./bar-chart";
import { FormState } from "./form-state";
import { GaugeChartSettings } from "./gauge-chart";
import { StatChartSettings } from "./stat-chart";
import { TimeSeriesChartSettings } from "./time-series-chart";

export interface SettingsProps {
	settings: FormState;
}

export const Settings: React.FC<SettingsProps> = ({ settings }) => {
	const kind = useScoped((scope) => settings.active.getOutput(scope), [settings]);
	const previousKind = usePrevious(kind);

	React.useEffect(() => {
		if (previousKind != null) {
			FormState.sync(previousKind, settings);
		}
	}, [previousKind, settings]);

	switch (kind) {
		case "TimeSeriesChart": {
			return <TimeSeriesChartSettings settings={settings.branches.TimeSeriesChart} />;
		}

		case "BarChart": {
			return <BarChartSettings settings={settings.branches.BarChart} />;
		}

		case "GaugeChart": {
			return <GaugeChartSettings settings={settings.branches.GaugeChart} />;
		}

		case "StatChart": {
			return <StatChartSettings settings={settings.branches.StatChart} />;
		}

		default: {
			return null;
		}
	}
};
